import React from 'react'

export default function GridContainer ({ children, gap, alignItems = '', justifyContent = '', py = '', mb = '', className = '' }) {
  const classJustify = justifyContent ? `justify-content-${justifyContent}` : ''
  const classAlign = alignItems ? ` align-items-${alignItems}` : ''
  return (
    <div className={
      `grid${gap ? ` gap-${gap}` : ''}${classAlign}${py ? ` py-${py}` : ''}${mb ? ` mb-${mb}` : ''} ${className} ${classJustify}`
    }>
      {children}
    </div>
  )
}
